import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Typography } from "@avenue-8/sidekick-ui";

export const SourceIconWrapper = styled.span<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(p) => (p.$compact ? "1.75rem" : "2rem")};
  height: ${(p) => (p.$compact ? "1.75rem" : "2rem")};
  border-radius: 0.5rem;
  background-color: ${(p) => p.theme.colors.background5};
  color: ${(p) => p.theme.icon.colors.primary};
`;

export const ContactName = styled(Typography)`
  color: ${(p) => p.theme.text.colors.brand};
`;

export const ScoreBadge = styled.div<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  min-width: ${(p) => (p.$compact ? "1.5rem" : "2rem")};
  height: ${(p) => (p.$compact ? "1.5rem" : "2rem")};
  padding: 0 ${(p) => (p.$compact ? "0.25rem" : "0.5rem")};
  border-radius: 999px;
  background-color: ${(p) => p.theme.navbar.colors.background};
`;

export const ScoreBadgeText = styled(Typography)<{
  "data-compact"?: boolean;
}>`
  color: ${(p) => p.theme.navbar.colors.text};
  ${(p) =>
    p["data-compact"] &&
    css`
      font-size: ${p.theme.text.fontSizes.xs};
      font-weight: 700;
      line-height: 1;
    `}
`;

export const ViewContactHint = styled(Typography)`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: ${(p) => p.theme.text.colors.brand};
  font-weight: 600;
  white-space: nowrap;

  svg {
    font-size: 1rem;
  }
`;

export const FailedIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.colors.warning};
`;
